import React from 'react';
import { ArrowRight, Image as ImageIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import toolPages from '../lib/toolPages';
import { getToolTone } from '../lib/toolVisuals';
import Seo, { SITE_URL } from './Seo';

const ToolsIndex = () => {
  return (
    <div className="page pt-32">
      <Seo
        title="Image Tools | CompressImages.org"
        description="Browse free browser-based image compression, resizing, and WebP conversion tools."
        path="/tools"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Image Tools',
          url: `${SITE_URL}/tools`,
          hasPart: toolPages.map((tool) => ({
            '@type': 'WebApplication',
            name: tool.title,
            url: `${SITE_URL}${tool.path}`,
          })),
        }}
      />

      <section className="section-hd">
        <h1>All image tools</h1>
        <p>Free, private, browser-based tools for compression, conversion, and resizing.</p>
      </section>

      <section className="tools-grid">
        {toolPages.map((tool) => (
          <Link key={tool.path} to={tool.path} className="tool-card">
            <div className={`tool-card-icon ${getToolTone(tool.path)}`}><ImageIcon /></div>
            <div>
              <div className="tool-name">{tool.title}</div>
              <div className="tool-desc">{tool.subtitle}</div>
            </div>
            <div className="tool-arrow"><ArrowRight /></div>
          </Link>
        ))}
      </section>
    </div>
  );
};

export default ToolsIndex;
